import * as actionTypes from "../actionTypes/Index";
import { metricsInitialState } from "./InitialState";
import { IActionType } from "../../interfaces/Index";

const initialState = { ...metricsInitialState };

export default function metricsReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {
    case actionTypes.CREATE_UPDATE_METRICS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        isMetricsUpdated: false,
      });
    }
    case actionTypes.CREATE_UPDATE_METRICS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isMetricsUpdated: true,
        metricsDetailsFetched: [],
      });
    }
    case actionTypes.CREATE_UPDATE_METRICS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
        isMetricsUpdated: false,
      });
    }

    case actionTypes.GET_METRICS_DETAILS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        metricsDetailsFetched: null,
      });
    }
    case actionTypes.GET_METRICS_DETAILS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isMetricsDetailsFetched: true,
        metricsDetailsFetched: action.payload,
      });
    }
    case actionTypes.GET_METRICS_DETAILS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
        isMetricsDetailsFetched: false,
      });
    }

    case actionTypes.GET_ALL_CORE_METRICS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        isCoreMetricsFetched: false,
        coreMetricsFetched: [{ id: "", name: "" }],
      });
    }
    case actionTypes.GET_ALL_CORE_METRICS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isCoreMetricsFetched: true,
        coreMetricsFetched: action.payload,
      });
    }
    case actionTypes.GET_ALL_CORE_METRICS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
        isCoreMetricsFetched: false,
      });
    }

    case actionTypes.GET_CATEGORIES_FOR_METRICS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        isCategoriesMetricsFetched: false,
        categoriesMetrics: [{ id: "", name: "" }],
      });
    }
    case actionTypes.GET_CATEGORIES_FOR_METRICS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isCategoriesMetricsFetched: true,
        categoriesMetrics: action.payload,
      });
    }
    case actionTypes.GET_CATEGORIES_FOR_METRICS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
        isCategoriesMetricsFetched: false,
      });
    }

    case actionTypes.METRICS_UPLOAD_INIT: {
      return Object.assign({}, state, {
        isMetricsUploading: true,
        isMetricsUploadingError: false,
        isMetricsUploaded: false,
        error: null,
      });
    }
    case actionTypes.METRICS_UPLOAD_SUCCESS: {
      return Object.assign({}, state, {
        isMetricsUploading: false,
        isMetricsUploaded: true,
      });
    }
    case actionTypes.METRICS_UPLOAD_FAIL: {
      return Object.assign({}, state, {
        isMetricsUploading: false,
        isMetricsUploadingError: true,
        isMetricsUploaded: false,
        error: action.error,
      });
    }

    default:
      return state;
  }
}
